/* eslint-disable import/prefer-default-export */
import * as moment from 'moment';
import utilityFunctions from './functions';

export function isWithinOneYear(value) {
  // IMPORTANT - not all moment functions work in safari, thats why I am comparing dates in JS
  if (value) {
    const slDate = new Date(moment(value, 'MM-DD-YYYY').format('YYYY-MM-DD')).getTime();
    const oneYearPrior = new Date(moment().subtract(365, 'days').format('YYYY-MM-DD')).getTime();
    return slDate >= oneYearPrior;
  }
  return true;
}

export function isBetweenStartAndEndDate(value, parentVm) {
  // IMPORTANT - not all moment functions work in safari, thats why I am comparing dates in JS
  if (value && parentVm && parentVm.serviceStartDate && parentVm.serviceEndDate) {
    const slDate = new Date(moment(value, 'MM-DD-YYYY').format('YYYY-MM-DD')).getTime();
    const projStart = new Date(moment(parentVm.serviceStartDate, 'MM-DD-YYYY').format('YYYY-MM-DD')).getTime();
    const projEnd = new Date(moment(parentVm.serviceEndDate, 'MM-DD-YYYY').format('YYYY-MM-DD')).getTime();
    return slDate >= projStart && slDate <= projEnd;
  }
  return true;
}

export function isNotFutureDate(value) {
  // IMPORTANT - not all moment functions work in safari, thats why I am comparing dates in JS
  if (value) {
    const slDate = new Date(moment(value, 'MM-DD-YYYY').format('YYYY-MM-DD')).getTime();
    const now = new Date().getTime();
    return now >= slDate;
  }
  return true;
}

export function areMinutesGreaterThanZero(value) {
  if (value) {
    return Number(value) > 0;
  }
  return true;
}

export function isValidMinutes(value, parentVm) {
  if (value) {
    const sessionTime =
      parentVm.sessionTime ? utilityFunctions.convertTimeToMinutes(parentVm.sessionTime, true) : null;
    const maxMinutes = 1440 - sessionTime;
    // make sure that the number is an integer
    return Number.isInteger(Number(value)) && (Number(value) <= 1440) && (maxMinutes >= value);
  }
  return true;
}

export function isSessionTimeEndGreaterThanSessionTime(value, parentVm) {
  if (value && parentVm && parentVm.sessionTime) {
    const startMil = utilityFunctions.calculateMilitaryTime(parentVm.sessionTime, true);
    const startTime = utilityFunctions.convertTimeToMinutes(startMil, true);
    const endMil = utilityFunctions.calculateMilitaryTime(value, false);
    if (startTime) {
      return utilityFunctions.convertTimeToMinutes(endMil, false) > startTime;
    }
  }
  return true;
}

export function isTotalMedicaidMinutesValid(value, parentVm) {
  if (value && parentVm && parentVm.serviceInformation.sessionMinutes) {
    const sessionMinutes = parentVm.serviceInformation.sessionMinutes;
    if (value > sessionMinutes) {
      return false;
    }
  }
  return true;
}

export function isTotalReimbursableMinutesValid(value, parentVm) {
  if (value && parentVm && parentVm.serviceInformation.sessionMinutes) {
    const sessionMinutes = parentVm.serviceInformation.sessionMinutes;
    if (sessionMinutes) {
      return sessionMinutes >= value;
    }
  }
  return true;
}



// WEBPACK FOOTER //
// ./src/utils/validations.js